// in profile/index.js
import ProfileEdit from "./ProfileEdit";
import PasswordEdit from "./changePassword";

export default {
  edit: ProfileEdit,
  password: PasswordEdit,
};
